import { SvgIcon } from '@/lib';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

export const SupportHeader: FC = () => {
  const { t } = useTranslation('support');

  return (
    <div className='flex flex-col gap-4'>
      <SvgIcon name='AudiencerateLogoIcon' className='mx-auto my-0 size-8' />
      <div className='flex flex-col items-center gap-0.5'>
        <h1 className='text-base font-semibold text-gray-900'>{t('modal.title')}</h1>
        <h2 className='text-sm text-tertiary-600'>{t('modal.description')}</h2>
      </div>
    </div>
  );
};
